'use client';
import { Button, cn } from '@shared/components/shadcn';
import { FRONTIFY_URL } from '@shared/utils';
import Image from 'next/image';
import Link from 'next/link';

const DEFAULT_ERROR_IMAGE_URL = `${FRONTIFY_URL}DWJH3gwL8cXTETToXjFP.svg`;

type GenericErrorProps = {
  title: string;
  subtitle: string;
  cta?: { link: string; text: string };
  altText: string;
  imageSrc?: string;
  imageContainerClassName?: string;
  imageClassName?: string;
};

function GenericError({ title, subtitle, cta, altText, imageSrc = DEFAULT_ERROR_IMAGE_URL, imageContainerClassName, imageClassName }: GenericErrorProps) {
  return (
    <div
      className="ll-container-inner flex flex-col items-center gap-7 px-5 w-full md:max-w-[640px] mx-auto"
      role="alert"
      aria-live="assertive"
      aria-labelledby="error-title"
      aria-describedby="error-description"
    >
      <div className={cn('relative w-full max-w-md mx-auto', imageContainerClassName)}>
        <Image
          src={imageSrc}
          width={400}
          height={300}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          className={cn('object-contain w-full h-auto', imageClassName)}
          alt={altText}
          priority
          fetchPriority="high"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-2 text-center">
        <h1 id="error-title" className="display-m md:display-xl">
          {title}
        </h1>
        <p id="error-description" className="text-foreground-subtle">
          {subtitle}
        </p>
      </div>
      {cta && (
        <Button asChild>
          <Link href={cta.link} data-testid="home-link">
            {cta.text}
          </Link>
        </Button>
      )}
    </div>
  );
}

export { GenericError };
